const r = {
  styleOverrides: {
    root: ({ theme: o }) => ({
      borderRadius: o.tokens.radius[4],
      borderColor: `${o.palette.other.divider}`
    })
  }
};
export {
  r as toggleButtonGroup
};
//# sourceMappingURL=toggleButtonGroup.mjs.map
